var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-gas",
    clipPath: "url(#clip0_1041_3312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5378 0.000824913C8.42802 0.0063801 8.32197 0.0410996 8.2331 0.100818C2.97494 3.72209 1.5 7.20932 1.5 10.8446C1.5 12.0633 2.02276 13.3166 2.92189 14.3C3.82102 15.2834 5.13018 15.9999 6.66171 15.9999C6.89994 16.0034 7.11576 15.8687 7.20312 15.6625C7.29125 15.4562 7.23225 15.2215 7.05601 15.0722C6.56164 14.6424 6.08817 13.7918 6.08817 12.8002C6.08817 12.0878 6.41227 11.2517 7.22329 10.3614C7.29423 10.71 7.41596 11.026 7.58175 11.3002C7.94693 11.9037 8.454 12.3279 8.86025 12.7057C9.2665 13.0835 9.55551 13.4043 9.64886 13.7279C9.74221 14.0514 9.70711 14.4639 9.23066 15.1889C9.12237 15.3534 9.11864 15.5597 9.2202 15.7277C9.32176 15.8958 9.51293 15.9999 9.72055 15.9999C12.3709 15.9999 14.5 13.5931 14.5 10.8447C14.5 8.91008 13.4202 7.65043 12.2776 6.25052C11.135 4.85062 9.86986 3.24717 9.12905 0.406469C9.06333 0.156494 8.81391 -0.0143385 8.53758 0.000949348L8.5378 0.000824913ZM8.28089 1.43406C9.09414 3.97007 10.3271 5.61707 11.3696 6.89485C12.5211 8.30656 13.353 9.27034 13.353 10.8446C13.353 12.6827 12.1559 14.2423 10.6884 14.7445C10.8385 14.2744 10.8661 13.8383 10.7541 13.4501C10.5667 12.8016 10.1029 12.3558 9.67277 11.9558C9.24262 11.5558 8.82964 11.1912 8.57946 10.7781C8.32929 10.3649 8.20384 9.9087 8.37035 9.17264C8.42039 8.94835 8.31136 8.71989 8.09852 8.60393C7.88642 8.48797 7.61833 8.51158 7.43238 8.66157C5.73791 10.0177 4.94114 11.4592 4.94114 12.8001C4.94114 13.4994 5.11663 14.1299 5.38922 14.6777C4.78133 14.4499 4.23768 14.0895 3.80005 13.6111C3.07566 12.8188 2.64702 11.7689 2.64702 10.8447C2.64702 7.61719 3.7807 4.72273 8.28089 1.43406Z",
    fill: "#A0A3A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1041_3312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnGas);
export default __webpack_public_path__ + "static/media/icn_gas.cc992aa38b077759b8103365ac5a4e11.svg";
export { ForwardRef as ReactComponent };